import React from "react";

const Footer = () => {
  return (
    <div className="ihub-footer">
      <div style={{ textAlign: "center" }}>Integrations Hub - Rixter AB</div>
    </div>
  );
};
export default Footer;
